import { render } from "./WorkItem.vue?vue&type=template&id=5d147e68&scoped=true"
import script from "./WorkItem.vue?vue&type=script&lang=js"
export * from "./WorkItem.vue?vue&type=script&lang=js"

import "./WorkItem.vue?vue&type=style&index=0&id=5d147e68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d147e68"]])

export default __exports__